const styles = (theme) => ({
    table: {
        margin: '0 0 30px 0',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    headTableCellDark: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
